import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import {
  ClientCategoryEdit,
  ClientEdit,
  ClientWithdrawalStatusEdit,
} from './types'
import { $params } from '../../../features/router'
import { Error } from './types'

export const clientEditProfileMounted = createEvent()
export const setClientEditProfile = createEvent<ClientEdit>()
export const setClientBan = createEvent()
export const setClientDelete = createEvent()

export const submitEditClient = createEvent<ClientEdit>()
export const submitEditClientCategory = createEvent<ClientEdit>()
export const submitEditAutoWithdrawalStatus = createEvent<ClientEdit>()

export const setError = createEvent<Error>()

export const $clientEditProfile = restore(setClientEditProfile, {
  clientId: '',
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  verified: false,
  country: '',
  fullName: '',
  hasDeposit: false,
  partner: false,
  autoDepositDisabled: true,
  autoWithdrawalStatus: true,
  registeredAt: '',
  address: '',
  phone: '',
  dateOfBirth: '',
  socialNetwork: '',
  avatarUrl: '',
  gender: '',
  products: [],
  language: '',
  saved: false,
  isViewStrategies: false,
  category: '',
})

export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const getClient = fx<void, ClientEdit>({
  method: 'GET',
  url: '/client/',
})

export const banClient = fx<ClientEdit, void>({
  method: 'PUT',
  url: '/client/',
})

export const updateClient = fx<ClientEdit, ClientEdit>({
  method: 'PUT',
  url: '/client/',
})

export const updateClientCategory = fx<ClientCategoryEdit, ClientEdit>({
  method: 'POST',
  url: '/client/{id}/category',
})

export const updateAutoWithdrawalStatus = fx<
  ClientWithdrawalStatusEdit,
  ClientEdit
>({
  method: 'POST',
  url: '/client/{id}/auto_withdrawal_status',
})

export const deleteClient = fx<ClientEdit, void>({
  method: 'DELETE',
  url: '/client/',
})

sample({
  clock: clientEditProfileMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.clientID
    }
    return {
      url: `/client/${id}`,
    }
  },
  target: getClient,
})

sample({
  clock: setClientBan,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.clientID
    }
    return {
      url: `/client/${id}`,
    }
  },
  target: banClient,
})

sample({
  clock: submitEditClient,
  source: $params,
  fn: (params, client) => {
    let id
    if (params) {
      id = params.clientID
    }
    if (client.phone && !client.phone.startsWith('+')) {
      client.phone = '+' + client.phone
    }
    return {
      url: `/client/${id}`,
      body: { ...client },
    }
  },
  target: updateClient,
})

sample({
  clock: submitEditClientCategory,
  source: $params,
  fn: (params, client) => {
    return {
      url: `/client/${params?.clientID}/category`,
      body: { category: client.category },
    }
  },
  target: updateClientCategory,
})

sample({
  clock: submitEditAutoWithdrawalStatus,
  source: $params,
  fn: (params, client) => {
    return {
      url: `/client/${params?.clientID}/auto_withdrawal_status`,
      body: { autoWithdrawalStatus: client.autoWithdrawalStatus },
    }
  },
  target: updateAutoWithdrawalStatus,
})

sample({
  clock: setClientDelete,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.clientID
    }
    return {
      url: `/client/${id}`,
    }
  },
  target: deleteClient,
})

// update profile model

sample({
  clock: getClient.doneData,
  fn: (doneData) => doneData.body,
  target: setClientEditProfile,
})
sample({
  clock: updateClient.doneData,
  fn: (doneData) => {
    return {
      ...doneData.body,
      saved: true,
    }
  },
  target: setClientEditProfile,
})

sample({
  clock: updateClient.doneData,
  fn: (doneData) => {
    return { message: '', code: doneData.status }
  },
  target: [setError],
})

sample({
  clock: updateAutoWithdrawalStatus.doneData,
  source: $params,
  fn: (params, doneData) => {
    return {
      url: `/client/${params?.clientID}`,
    }
  },
  target: getClient,
})

sample({
  clock: updateClient.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: updateClient.failData,
  source: $params,
  fn: (params) => {
    return {
      url: `/client/${params?.clientID}`,
    }
  },
  target: getClient,
})
